<template>
    <div>
        <section>
            <div v-if="example">
                <div class="table-responsive" style="min-height: 300px;">
                    <table class="table table-sm table-hover table-bordered vld-parent" ref="tableContainer">
                        <thead>
                            <tr>
                                <th v-for="column in data.columns" :key="column.field"
                                    :class="[' titulo-tabla th-sm text-center px-0 py-0', column.col]">
                                    <button v-if="column.isSortable === true" v-on:click="sort(column.field)"
                                        class="btn btn-sm btn-block">
                                        {{ column.label }}
                                    </button>
                                    <p v-else>{{ column.label }}</p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(project, idx) in example" :key="idx">
                                <td>
                                    <p>
                                        <a :href="`https://www.senado.cl/appsenado/templates/tramitacion/index.php?boletin_ini=${project.PROYNUMEROBOLETIN}`"
                                            target="_blank">{{ project.PROYNUMEROBOLETIN }}</a>
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        {{ project.AUTORES }}
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p class='mt-3' v-if="boletinesRefundidos">Boletines refundidos no encontrados {{ boletinesRefundidos }}</p>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import axios from '../../../backend/axios';
import Axios from 'axios';
import { BModal } from 'bootstrap-vue';
import Loading from 'vue-loading-overlay';
import Multiselect from 'vue-multiselect';

export default {
    name: 'TablaList',
    components: {
        Loading,
        BModal,
        Multiselect,
    },
    props: {
        projects: String
    },
    data() {
        return {
            //projects: [],
            cont: 0,
            example: [],
            letra: [],
            noEncontrados: [],
            generalInfoProjectUrl: '',
            dataList: [],
            allProjects: [],
            totalRows: 0,
            returnedRows: 0,
            currentPage: 1,
            currentSort: {
                field: 'boletin',
                type: 'ASC',
            },
            limit: 10,
            offset: 0,
            query: '',
            fail: null,
            data: {
                columns: [
                    {
                        col: "col-3",
                        label: "N° Boletín refundido",
                        field: "PROYNUMEROBOLETIN",
                        isSortable: true,
                        customizable: false
                    },
                    {
                        col: "col-auto",
                        label: "Autoría",
                        field: "AUTORES",
                        isSortable: true,
                        customizable: false
                    }
                ],
                rows: []
            },
            loadProjects: false,
            loadBtnDownloadReports: [],
            fullPage: false,
            color: '#000000',
            mode: String,
            exportInfo: null,
            exportTipo: null,
            exportFormat: null,
            loading: [
                { tipo_export: "proyectos_participacion", formato: "csv", estado: false },
                { tipo_export: "proyectos_participacion", formato: "xlsx", estado: false },
                { tipo_export: "proyectos_resumen", formato: "csv", estado: false },
                { tipo_export: "proyectos_resumen", formato: "xlsx", estado: false },
                { tipo_export: "projects_report", formato: "csv", estado: false },
                { tipo_export: "projects_report", formato: "xlsx", estado: false },
            ],
            loadexportmodal: false,
            proyectosfiltro: null,
        }
    },
    mounted() {

        if ((this.$store.getters.modo_oscuro === 'dark') || (window.location.href.includes('dark'))) {
            this.mode = 'dark';
        } else {
            this.mode = 'light';
        }
        this.getBoletinRefund();
    },
    computed: {
        boletinesRefundidos() {
            const boletines = this.projects.split(','); // [ "00001-01", "10018-07", "15763-12", "14561-19", "00001-02" ]
            const auxData = this.example;
            const coinciden = [];
            const noCoinciden = [];

            for (let i = 0; i < boletines.length; i++) {
                for (let n = 0; n < auxData.length; n++) {
                    if (boletines[i] === auxData[n].PROYNUMEROBOLETIN) {
                        coinciden.push(boletines[i]);
                        break
                    } else {
                        if (n + 1 === auxData.length) {
                            noCoinciden.push(boletines[i]);
                        }

                    }

                }
            }
            return noCoinciden.join(' , ')


        }
    },
    methods: {
        getBoletinRefund() {
            const arrayProject = this.projects.split(','); // [ "00001-01", "10018-07", "15763-12", "14561-19", "00001-02" ]

            axios.get('settings', {
                params: {
                    key: 'external_api'
                }
            }).then(response => {
                const urls = response.data.map(item => JSON.parse(item.value).general_info_project)
                const generalInfoProjectUrl = urls[0];

                const requests = arrayProject.map((x) => {
                    return Axios.create().get(generalInfoProjectUrl + x);
                });

                Promise.all(requests)
                    .then(responses => {
                        this.data.rows = responses.map(resp => resp.data[0]);
                        this.example = this.data.rows.filter(fil => fil !== undefined)

                    })
                    .catch(error => {
                        this.error = error;
                    });
            }).catch(error => {
                this.error = error;
            });

        },
        sort(field) {
            if (field === this.currentSort.field) {
                if (this.currentSort.type === 'ASC') {
                    this.currentSort.type = 'DESC';
                } else {
                    this.currentSort.type = 'ASC';
                }
            } else {
                this.currentSort.field = field;
                this.currentSort.type = 'ASC';
            }
            this.getProjects(1);
        },
        updateLimit(event) {
            this.limit = event.target.value;
            this.getProjects(1);
        },
    }
}
</script>

<style scoped>
.table.table-bordered th {
    border-top: none !important;
}

/* 
table.table.table-sm.table-hover.table-bordered.vld-parent thead tr th{
    padding: 0 !important;
} */

table.table.table-sm.table-hover.table-bordered.vld-parent thead tr th:nth-child(1) {
    padding: 0 20px 0 0 !important;
}

/* table.table.table-sm.table-hover.table-bordered.vld-parent thead tr th:nth-child(2){
  border-left: solid 1px #e0e3e4 !important;
} */

table.table.table-sm.table-hover.table-bordered.vld-parent tbody tr td:nth-child(2) {
    border-left: solid 1px #e0e3e4 !important;
}

.titulo-tabla {
    padding: 0 !important;
}

.titulo-tabla button {
    font-size: 1.25rem;
    font-weight: 500 !important;
}
</style>